import { useT } from '../../i18n/index.ts';
import { FormField, Textarea } from '../../ui/index.ts';
import { DISABLED_NOTE_MAX_CHARS } from './disabledNote.ts';

/**
 * Optional 备注 for a manual target disable (0082). The gateway rejects
 * control characters, so the caller sends it through `disabledNoteForWire`.
 */
export function DisabledNoteField({
  value,
  onChange,
  fieldId,
  testId,
}: {
  readonly value: string;
  readonly onChange: (value: string) => void;
  readonly fieldId: string;
  readonly testId: string;
}): JSX.Element {
  const t = useT();
  return (
    <FormField
      label={t('tenant_routing.disabled_note.label')}
      fieldId={fieldId}
      hint={t('tenant_routing.disabled_note.count', {
        count: String(Array.from(value).length),
        max: String(DISABLED_NOTE_MAX_CHARS),
      })}
    >
      <Textarea
        id={fieldId}
        rows={2}
        maxLength={DISABLED_NOTE_MAX_CHARS}
        value={value}
        placeholder={t('tenant_routing.disabled_note.placeholder')}
        onChange={(event) => onChange(event.currentTarget.value)}
        data-testid={testId}
      />
    </FormField>
  );
}
